export default {
  name: 'security-basis',
  path: 'security-basis',
  component: () => import('@/views/container/Redirect.vue'),
  meta: {
    title: '安全基础管理',
    redirect: true,
    hideSubMenu: true,
    icon: 'icon-a-jianqu17'
  },
  children: [
    {
      name: 'comprehensive-stat',
      path: 'comprehensive-stat',
      component: () => import('@/views/security-basis/comprehensive-stat/ComprehensiveStat.vue'),
      meta: { title: '综合看板' }
    },
    {
      name: 'unit-base-info',
      path: 'unit-base-info',
      component: () => import('@/views/security-basis/unit-base-info/UnitBaseInfo.vue'),
      meta: {
        title: '企业基本信息',
        icon: 'icon-home'
      }
    }, {
      name: 'qualification-certificate',
      path: 'qualification-certificate',
      component: () => import('@/views/security-basis/qualification-certificate/QualificationCertificate.vue'),
      meta: {
        title: '资质证照信息',
        icon: 'icon-creditcard'
      }
    }, {
      name: 'organization',
      path: 'organization',
      component: () => import('@/views/security-basis/organization/Organization.vue'),
      meta: {
        title: '组织机构管理',
        icon: 'icon-fork'
      }
    }, {
      name: 'area-management',
      path: 'area-management',
      component: () => import('@/views/security-basis/area-management/AreaManagement.vue'),
      meta: {
        title: '企业区域管理',
        icon: 'icon-location'
      }
    }, {
      name: 'interested-party',
      path: 'interested-party',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '相关方管理',
        redirect: true,
        icon: 'icon-usergroup'
      },
      children: [
        {
          name: 'contractor-management',
          path: 'contractor-management',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '承包商管理',
            redirect: true
          },
          children: [
            {
              name: 'contractor-management-index',
              path: '',
              component: () => import('@/views/security-basis/interested-party/contractor-management/ContractorManagement.vue'),
              meta: { title: '承包商管理' }
            }
          ]
        }, {
          name: 'project-management',
          path: 'project-management',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '承包商项目管理',
            redirect: true
          },
          children: [
            {
              name: 'project-management-index',
              path: '',
              component: () => import('@/views/security-basis/interested-party/project-management/ProjectManagement.vue'),
              meta: { title: '承包商项目管理' }
            }, {
              name: 'project-detail',
              path: 'project-detail',
              component: () => import('@/views/security-basis/interested-party/project-management/ProjectDetail.vue'),
              meta: { title: '承包项目详情' }
            }
          ]
        }
      ]
    }, {
      name: 'put-into',
      path: 'put-into',
      component: () => import('@/views/security-basis/put-into/PutInto.vue'),
      meta: { title: '安全投入' }
    }, {
      name: 'meeting',
      path: 'meeting',
      meta: {
        title: '安全会议',
        redirect: true
      },
      component: () => import('@/views/container/Redirect.vue'),
      children: [
        {
          name: 'meeting-list',
          path: 'meeting-list',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '安全会议',
            redirect: true
          },
          children: [
            {
              name: 'meeting-list-page',
              path: '',
              component: () => import('@/views/security-basis/meeting/list/List.vue'),
              meta: { title: '安全会议' }
            }, {
              name: 'meeting-detail',
              path: 'detail',
              component: () => import('@/views/security-basis/meeting/detail/Detail.vue'),
              meta: {
                title: '安全会议详情',
                noLimits: true
              }
            }
          ]
        }, {
          name: 'meeting-record',
          path: 'meeting-record',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '我的安全会议',
            redirect: true
          },
          children: [
            {
              name: 'meeting-record-list',
              path: '',
              component: () => import('@/views/security-basis/meeting-record/list/List.vue'),
              meta: { title: '我的安全会议' }
            }, {
              name: 'meeting-record-detail',
              path: 'detail',
              component: () => import('@/views/security-basis/meeting-record/detail/Detail.vue'),
              meta: {
                title: '我的安全会议详情',
                noLimits: true
              }
            }
          ]
        }
      ]
    }, {
      name: 'work-health',
      path: 'work-health',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '职业健康管理',
        redirect: true,
        icon: 'icon-usergroup'
      },
      children: [
        {
          name: 'health-file',
          path: 'health-file',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '职业卫生档案',
            redirect: true
          },
          children: [
            {
              name: 'health-file-index',
              path: '',
              component: () => import('@/views/security-basis/work-health/health-file/HealthFile.vue'),
              meta: { title: '职业卫生档案' }
            }, {
              name: 'three-meanwhile',
              path: 'three-meanwhile',
              component: () => import('@/views/security-basis/work-health/health-file/ThreeMeanwhile.vue'),
              meta: { title: '职业危害三同时' }
            }, {
              name: 'update-record',
              path: 'update-record',
              component: () => import('@/views/security-basis/work-health/health-file/UpdateRecord.vue'),
              meta: { title: '危害因素更新记录' }
            }, {
              name: 'harm-declare',
              path: 'harm-declare',
              component: () => import('@/views/security-basis/work-health/health-file/HarmDeclare.vue'),
              meta: { title: '职业危害申报' }
            }, {
              name: 'harm-evaluate',
              path: 'harm-evaluate',
              component: () => import('@/views/security-basis/work-health/health-file/HarmEvaluate.vue'),
              meta: { title: '职业危害检测与评价' }
            }
          ]
        }, {
          name: 'protect-file',
          path: 'protect-file',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '健康监护档案',
            redirect: true
          },
          children: [
            {
              name: 'protect-file-index',
              path: '',
              component: () => import('@/views/security-basis/work-health/protect-file/ProtectFile.vue'),
              meta: { title: '健康监护档案' }
            }
          ]
        }, {
          name: 'personal-health',
          path: 'personal-health',
          component: () => import('@/views/security-basis/work-health/personal-health/PersonalHealth.vue'),
          meta: { title: '个人健康管理' }
        }
      ]
    }, {
      name: 'institution',
      path: 'institution',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '安全规章制度',
        redirect: true
      },
      children: [
        {
          name: 'institution-manage',
          path: 'institution-manage',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '规章制度管理',
            redirect: true
          },
          children: [
            {
              name: 'institution-manage-list',
              path: 'list',
              component: () => import('@/views/security-basis/institution/manage/list/List.vue'),
              meta: { title: '列表' }
            }, {
              name: 'institution-manage-history',
              path: 'history',
              component: () => import('@/views/security-basis/institution/manage/history/History.vue'),
              meta: { title: '修订历史' }
            }, {
              name: 'institution-manage-preview',
              path: 'preview',
              component: () => import('@/views/security-basis/institution/manage/preview/Preview.vue'),
              meta: { title: '预览文件' }
            }
          ]
        }, {
          name: 'institution-mine',
          path: 'institution-mine',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '我的规章制度',
            redirect: true
          },
          children: [
            {
              name: 'institution-mine-list',
              path: 'list',
              component: () => import('@/views/security-basis/institution/mine/list/List.vue'),
              meta: { title: '列表' }
            }, {
              name: 'institution-mine-preview',
              path: 'preview',
              component: () => import('@/views/security-basis/institution/mine/preview/Preview.vue'),
              meta: { title: '预览文件' }
            }
          ]
        }
      ]
    }, {
      name: 'regulation',
      path: 'regulation',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '安全操作规程',
        redirect: true
      },
      children: [
        {
          name: 'regulation-manage',
          path: 'regulation-manage',
          component: () => import('@/views/security-basis/regulation/manage/Manage.vue'),
          meta: { title: '操作规程管理' }
        }, {
          name: 'regulation-mine',
          path: 'regulation-mine',
          component: () => import('@/views/security-basis/regulation/mine/Mine.vue'),
          meta: { title: '我的操作规程' }
        }
      ]
    }, {
      name: 'regulatory-standards',
      path: 'regulatory-standards',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '法规标准识别',
        redirect: true
      },
      children: [
        {
          name: 'regulatory-standards-manage',
          path: 'regulatory-standards-manage',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '法规标准管理',
            redirect: true
          },
          children: [
            {
              name: 'regulatory-standards-manage-list',
              path: '',
              component: () => import('@/views/security-basis/regulatory-standards/manage/ManageList.vue'),
              meta: { title: '法规标准管理' }
            }, {
              name: 'regulatory-manage-history',
              path: 'history',
              component: () => import('@/views/security-basis/regulatory-standards/manage/RecognizeHistory.vue'),
              meta: { title: '识别历史' }
            }, {
              name: 'regulatory-manage-preview',
              path: 'preview',
              component: () => import('@/views/security-basis/regulatory-standards/PreviewDetails.vue'),
              meta: { title: '预览文件' }
            }
          ]
        }, {
          name: 'regulatory-standards-mine',
          path: 'regulatory-standards-mine',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '我的法规标准',
            redirect: true
          },
          children: [
            {
              name: 'regulatory-standards-mine-list',
              path: '',
              component: () => import('@/views/security-basis/regulatory-standards/mine/MineList.vue'),
              meta: { title: '我的法规标准' }
            }, {
              name: 'regulatory-mine-preview',
              path: 'preview',
              component: () => import('@/views/security-basis/regulatory-standards/PreviewDetails.vue'),
              meta: { title: '预览文件' }
            }
          ]
        }
      ]
    }, {
      name: 'safe-duty-book',
      path: 'safe-duty-book',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '安全责任书',
        redirect: true,
        icon: 'icon-usergroup'
      },
      children: [
        {
          name: 'duty-book',
          path: 'duty-book',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '安全责任书管理',
            redirect: true
          },
          children: [
            {
              name: 'duty-book-index',
              path: '',
              component: () => import('@/views/security-basis/safe-duty-book/duty-book/DutyBook.vue'),
              meta: { title: '安全责任书管理' }
            }, {
              name: 'book-detail',
              path: 'book-detail',
              component: () => import('@/views/security-basis/safe-duty-book/duty-book/BookDetail.vue'),
              meta: { title: '安全责任书详情' }
            }, {
              name: 'book-history',
              path: 'book-history',
              component: () => import('@/views/security-basis/safe-duty-book/duty-book/BookHistory.vue'),
              meta: { title: '历史记录' }
            }
          ]
        }, {
          name: 'my-duty-book',
          path: 'my-duty-book',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '我的安全责任书',
            redirect: true
          },
          children: [
            {
              name: 'my-duty-book-index',
              path: '',
              component: () => import('@/views/security-basis/safe-duty-book/my-duty-book/MyBook.vue'),
              meta: { title: '我的安全责任书' }
            }, {
              name: 'my-book-detail',
              path: 'my-book-detail',
              component: () => import('@/views/security-basis/safe-duty-book/duty-book/BookDetail.vue'),
              meta: { title: '安全责任书详情' }
            }
          ]
        }
      ]
    }
  ]
};
